<template>
  <nav class="dashboard_menu">
    <div class="nav nav-tabs" role="tablist">
      <router-link
          :to="{ name: 'dashboardPracticeManagerInfo'}"
          :class="{ active: $route.name === 'dashboardPracticeManagerInfo' }"
          class="nav-item nav-link active" role="tab">
        {{ $t('dashboard.tabs.info') }}
      </router-link>
      <router-link
          :to="{ name: 'dashboardPracticeManagerUnitsDoneByLocation' }"
          :class="{ active: $route.name === 'dashboardPracticeManagerUnitsDoneByLocation' }"
          class="nav-item nav-link" role="tab">
        {{ $t('dashboard.tabs.filterLocation') }}
      </router-link>
      <router-link
          :to="{ name: 'dashboardPracticeManagerUnitsPotentialUnits' }"
          :class="{ active: $route.name === 'dashboardPracticeManagerUnitsPotentialUnits' }"
          class="nav-item nav-link" role="tab">
        {{ $t('dashboard.tabs.preview_units_locations') }}
      </router-link>
    </div>
  </nav>
</template>

<script setup>
import { RouterLink } from 'vue-router';
</script>

<style scoped>
</style>